import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect } from 'react';
import { AppRoot, SplitLayout, SplitCol, View, ModalRoot, ModalPage, ModalPageHeader, PanelHeaderButton, Div, Snackbar, ScreenSpinner, FormItem, Input, Button, Card, CardGrid, Header, Textarea } from '@vkontakte/vkui';
import { QRCodeSVG } from 'qrcode.react';
import copy from 'copy-to-clipboard';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Icon24Dismiss, Icon28CancelCircleFillRed, Icon28CheckCircleFill } from '@vkontakte/icons';
import { BigNumber } from 'ethers';
import '@vkontakte/vkui/dist/vkui.css';
import './style.css';
import './main.css';
import { VldBuilder, vlds } from 'validatorus-react';
import { Main } from './pages/main';
import { Register } from './pages/register';
import { Reg } from './pages/reg';
import { Send } from './pages/send';
import { Settings } from './pages/settings';
import { Token } from './pages/token';
import { WalletETH } from './logic/wallet';
import { listTokens } from './logic/list';
import { getPriceToken, packTokens, sleep, weiToEth } from './logic/utils';
export const App = () => {
    const [activeModal, setActiveModal] = React.useState(null);
    const [snackbar, setSnackbar] = React.useState(null);
    const [popout, setPopout] = React.useState(null);
    const [firstRender, setFirstRender] = React.useState(false);
    const [firstRender2, setFirstRender2] = React.useState(false);
    const [wallet, setWallet] = React.useState(undefined);
    const [userTokens, setUserTokens] = React.useState(listTokens);
    const [walletBsc, setWalletBsc] = React.useState(undefined);
    const [walletPolygon, setWalletPolygon] = React.useState(undefined);
    const [balanceUser, setBalanceUser] = React.useState(0);
    const [errorText, setErrorText] = React.useState('');
    const [viewPosition, setViewPosition] = React.useState(0);
    const [private1, setPrivate1] = React.useState('');
    const [private2, setPrivate2] = React.useState('');
    const [currentToken, setCurrentToken] = React.useState(undefined);
    const isDesktop = window.innerWidth >= 800;
    const location = useLocation();
    const history = useNavigate();
    const psw = new VldBuilder()
        .with(vlds.VLen, 8, 128)
        .withFname('Password');
    function openPop() {
        setPopout(_jsx(ScreenSpinner, { state: "loading" }));
    }
    function closePop(type) {
        if (popout) {
            if (type)
                setPopout(_jsx(ScreenSpinner, { state: "done", "aria-label": "Success" }));
            else
                setPopout(_jsx(ScreenSpinner, { state: "error", "aria-label": "Error" }));
            setTimeout(() => {
                setPopout(null);
            }, 1000);
        }
        else {
            setPopout(null);
            console.log('dont have popout');
        }
    }
    function consoleLog(data, type = false) {
        setSnackbar(_jsx(Snackbar, { before: type ? _jsx(Icon28CheckCircleFill, {}) : _jsx(Icon28CancelCircleFillRed, {}), onClose: () => setSnackbar(null), children: data }));
    }
    async function loadWallet(psw) {
        const _wallet = await new WalletETH(0).syncWallet({ psw });
        const _wallet2 = await new WalletETH(1).syncWallet({ psw });
        const _wallet3 = await new WalletETH(2).syncWallet({ psw });
        if (_wallet.error || _wallet2.error || _wallet3.error) {
            return;
        }
        setWallet(_wallet);
        setWalletBsc(_wallet2);
        setWalletPolygon(_wallet3);
        history('/');
        console.log(_wallet.wallet?.address);
    }
    async function calculateBalance() {
        const list = await getPriceToken(packTokens(userTokens));
        console.log(list);
        if (list === undefined) {
            return false;
        }
        let fullBalance = 0;
        for (let i = 0; i < list.length; i++) {
            const amount = weiToEth((BigInt((list[i][0]?.balance ?? 0))
                + BigInt((list[i][1]?.balance ?? 0))
                + BigInt((list[i][2]?.balance ?? 0))).toString(), list[i][0].decimals);
            fullBalance += Number(amount) * Number(list[i][0].price);
        }
        setBalanceUser(Number(fullBalance));
        return true;
    }
    async function getBalance(network = 0) {
        // openPop()
        if (!wallet || !walletBsc || !walletPolygon) {
            closePop(false);
            console.error('not found wallets');
            return undefined;
        }
        // const _userTokens = userTokens
        let bl = BigNumber.from(0);
        if (network === 0) {
            bl = await wallet.getBalance();
            // _userTokens[0].balance = bl.toString()
        }
        if (network === 1) {
            bl = await walletBsc.getBalance();
            // _userTokens[1].balance = bl.toString()
        }
        if (network === 2) {
            bl = await walletPolygon.getBalance();
            // _userTokens[2].balance = bl.toString()
        }
        if (!bl) {
            console.log('error get balance');
            closePop(false);
            return undefined;
        }
        // console.log('bl', bl)
        // closePop(true)
        // setUserTokens(_userTokens)
        // setUserTokens(_userTokens)
        // getBalancesTokens()
        return bl;
    }
    async function getBalances() {
        if (wallet) {
            // openPop()
            console.log('update balance...');
            const proms = [getBalance(0), getBalance(1), getBalance(2), getBalancesTokens()];
            // await getBalance(0)
            // await getBalance(1)
            // await getBalance(2)
            const balances = await Promise.all(proms);
            // console.log(balances)
            const newArrayBalances = balances.slice(0, 3).concat(balances[3]);
            // console.log('newArrayBalances', newArrayBalances)
            const _userTokens = userTokens;
            for (let i = 0; i < userTokens.length; i++) {
                const bal = newArrayBalances[i] ? newArrayBalances[i]?.toString() ?? '0' : '0';
                _userTokens[i].balance = bal;
            }
            setUserTokens(_userTokens);
            // reRender()
            try {
                await calculateBalance();
            }
            catch (error) {
                console.error(error);
            }
            // closePop(true)
            // reRender()
        }
        else {
            console.log('wallet no found', walletBsc);
        }
        await sleep(5000);
        getBalances();
    }
    async function getBalancesTokens() {
        if (!wallet || !walletBsc || !walletPolygon) {
            closePop(false);
            return undefined;
        }
        const prom = [];
        for (let i = 3; i < userTokens.length; i++) {
            let bl;
            if (userTokens[i].network === 0) {
                bl = wallet.getBalanceToken(userTokens[i].address);
            }
            if (userTokens[i].network === 1) {
                bl = walletBsc.getBalanceToken(userTokens[i].address);
            }
            if (userTokens[i].network === 2) {
                bl = walletPolygon.getBalanceToken(userTokens[i].address);
            }
            if (!bl) {
                console.log('error get balance');
                return undefined;
            }
            prom.push(bl);
            // console.log(userTokens[i].name, bl)
        }
        const res = await Promise.all(prom);
        // for (let i = 3; i < userTokens.length; i++) {
        //     _userTokens[i].balance = res[i - 3] ? res[i - 3].toString() : '0'
        // }
        // setUserTokens(_userTokens)
        // closePop(true)
        return res;
        // await calculateBalance()
        // reRender()
    }
    async function deletedAccount() {
        if (!wallet || !walletBsc || !walletPolygon) {
            return;
        }
        const all = [
            wallet.delWallet(psw.value),
            walletBsc.delWallet(psw.value),
            walletPolygon.delWallet(psw.value)
        ];
        const res = await Promise.all(all);
        psw.reset();
        if (!res[0] || !res[1] || !res[2]) {
            setErrorText('Incorrect password');
            consoleLog('Incorrect password', false);
            return;
        }
        history('/reg');
        // setAddressUser(undefined)
        // setListTokens(undefined)
        // setWalletInfo(undefined)
        setErrorText('');
        setActiveModal(null);
        setWallet(undefined);
        setWalletBsc(undefined);
        setWalletPolygon(undefined);
        consoleLog('Success deleted', true);
    }
    async function viewAccount() {
        if (!wallet || !walletBsc || !walletPolygon) {
            return undefined;
        }
        const data = await wallet.loadHashSaveData();
        const privateKey = WalletETH.HashToKey(psw.value, data.iv, data.hash);
        if (!privateKey) {
            consoleLog('#4003 incorrect password');
            return undefined;
        }
        setPrivate1(privateKey);
        setPrivate2(wallet.wallet?.privateKey ?? '');
        setViewPosition(1);
        return privateKey;
    }
    async function openCurrentToken(token) {
        console.log(token);
        setCurrentToken(token);
        history('/token');
    }
    useEffect(() => {
        if (!firstRender) {
            setFirstRender(true);
            const reg = new WalletETH().isSaveWallet();
            if (!reg) {
                history('/reg');
            }
            else {
                history('/login');
            }
            // getBalances()
            // checkAuth()
        }
    }, []);
    useEffect(() => {
        if (wallet && walletBsc && walletPolygon && !firstRender2) {
            setFirstRender2(true);
            getBalances();
        }
    }, [wallet, walletBsc, walletPolygon]);
    useEffect(() => {
        if (activeModal === null) {
            // AddressSend.reset(true, true)
            // AmountSend.reset(true, true)
            psw.reset(true, true);
            setPrivate1('');
            setPrivate2('');
        }
    }, [activeModal]);
    const modalRoot = (_jsxs(ModalRoot, { activeModal: activeModal, children: [_jsx(ModalPage, { id: 'recive', className: "polus", onClose: () => setActiveModal(null), dynamicContentHeight: true, settlingHeight: 100, header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Receive" }), children: wallet
                    ? _jsxs(Div, { style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            width: '100%',
                            boxSizing: 'border-box'
                        }, children: [_jsx(Header, { children: "Get any tokens" }), _jsx("div", { className: "qr-block", children: _jsx(QRCodeSVG, { value: wallet.wallet?.address ?? '', size: 200 }) }), _jsx(CardGrid, { size: "l", children: _jsx(Card, { children: _jsx(Div, { children: _jsx("span", { style: {
                                                userSelect: 'all',
                                                fontSize: '12px'
                                            }, children: wallet.wallet?.address }) }) }) }), _jsx(Div, { style: { width: '100%', boxSizing: 'border-box', paddingTop: '0', marginTop: '0' }, children: _jsx(Div, { children: _jsx(Button, { style: { marginTop: '12px' }, stretched: true, size: 'l', onClick: () => {
                                            copy(wallet.wallet?.address ?? '');
                                            consoleLog('Copyed', true);
                                        }, children: "Copy address" }) }) })] })
                    : null }), _jsx(ModalPage, { id: 'del_wallet', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Delete account" }), children: _jsxs(Div, { children: [_jsx(FormItem, { top: "Password", bottom: psw.error, children: _jsx(Input, { value: psw.value, onChange: e => psw.change(e.target.value), status: psw.iserr, type: "password" }) }), _jsx(FormItem, { bottom: errorText, children: _jsx(Button, { style: { marginTop: '22px' }, stretched: true, size: 'l', disabled: psw.iserr !== 'valid', onClick: () => deletedAccount(), children: "Delete" }) })] }) }), _jsx(ModalPage, { id: 'view_key', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                dynamicContentHeight: true, header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "View private key" }), children: _jsxs(Div, { children: [viewPosition === 0 ? _jsx(FormItem, { top: "Password", bottom: psw.error, children: _jsx(Input, { value: psw.value, onChange: e => psw.change(e.target.value), status: psw.iserr, type: "password" }) }) : null, viewPosition === 0 ? _jsx(FormItem, { bottom: errorText, children: _jsx(Button, { style: { marginTop: '22px' }, stretched: true, size: 'l', disabled: psw.iserr !== 'valid', onClick: () => viewAccount(), children: "View" }) }) : null, viewPosition === 1
                            ? _jsxs("div", { children: [_jsx(FormItem, { top: "12 word", children: _jsx(Textarea, { value: private1, onChange: e => null, onClick: () => {
                                                copy(private1);
                                                consoleLog('Copyed', true);
                                            } }) }), _jsx(FormItem, { top: "Private key", children: _jsx(Textarea, { value: private2, onChange: e => null, onClick: () => {
                                                copy(private2);
                                                consoleLog('Copyed', true);
                                            } }) })] }) : null] }) })] }));
    return (_jsx(AppRoot, { children: _jsxs(SplitLayout, { className: "polus", style: { justifyContent: 'center' }, modal: modalRoot, popout: popout, children: [_jsx(SplitCol, { animate: false, spaced: isDesktop, width: isDesktop ? '350px' : '100%', maxWidth: isDesktop ? '350px' : '100%', children: _jsx("div", { id: "main", children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(View, { activePanel: 'main1', id: "view", children: _jsx(Main, { id: "main1", setActiveModal: setActiveModal, consoleLog: consoleLog, isDesktop: isDesktop, openPop: openPop, closePop: closePop, wallet: wallet, walletBsc: walletBsc, walletPolygon: walletPolygon, setUserTokens: setUserTokens, userTokens: userTokens, balanceUser: balanceUser, openCurrentToken: openCurrentToken }) }) }), _jsx(Route, { path: "/send", element: _jsx(View, { activePanel: 'send', id: "view", children: _jsx(Send, { id: "send", setActiveModal: setActiveModal, consoleLog: consoleLog, isDesktop: isDesktop, openPop: openPop, closePop: closePop, wallet: wallet, walletBsc: walletBsc, walletPolygon: walletPolygon, setUserTokens: setUserTokens, userTokens: userTokens, balanceUser: balanceUser }) }) }), _jsx(Route, { path: "/token", element: _jsx(View, { activePanel: 'token', id: "view", children: _jsx(Token, { id: "token", setActiveModal: setActiveModal, consoleLog: consoleLog, isDesktop: isDesktop, openPop: openPop, closePop: closePop, wallet: wallet, walletBsc: walletBsc, walletPolygon: walletPolygon, userTokens: userTokens, currentToken: currentToken }) }) }), _jsx(Route, { path: "/settings", element: _jsx(View, { activePanel: 'settings', id: "view", children: _jsx(Settings, { id: "settings", setActiveModal: setActiveModal, consoleLog: consoleLog }) }) }), _jsx(Route, { path: "/login", element: _jsx(View, { activePanel: 'login', id: "view", children: _jsx(Register, { id: "login", setActiveModal: setActiveModal, consoleLog: consoleLog, isDesktop: isDesktop, openPop: openPop, closePop: closePop, loadWallet: loadWallet }) }) }), _jsx(Route, { path: "/reg", element: _jsx(View, { activePanel: 'reg', id: "view", children: _jsx(Reg, { id: "reg", setActiveModal: setActiveModal, consoleLog: consoleLog, loadWallet: loadWallet }) }) })] }) }) }), snackbar] }) }));
};
